var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground768(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 800,
    viewBox: "0 0 512 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 762,
    cy: 360,
    rx: 360,
    ry: 540,
    fill: "#182347",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 760,
    cy: 358,
    rx: 330,
    ry: 495,
    fill: "#4465D2",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 764,
    cy: 359,
    rx: 245,
    ry: 370,
    fill: "#4465D2",
    fillOpacity: 0.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 765,
    cy: 400,
    rx: 178,
    ry: 268,
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0",
    x: 0,
    y: -600,
    width: 1600,
    height: 1900,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1",
    x: 0,
    y: -550,
    width: 1500,
    height: 1800,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2",
    x: 100,
    y: -400,
    width: 1300,
    height: 1500,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3",
    x: 380,
    y: -70,
    width: 760,
    height: 950,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground768);
export default __webpack_public_path__ + "static/media/background-768.2d7cd6a3c84c3118cdd678a3506cd454.svg";
export { ForwardRef as ReactComponent };